import React, {useEffect} from 'react';
import Home_page from '../Component/Home_page'
import Main_Brand_slider from '../Component/Main_Brand_slider'
import Seconde_Component from '../Component/Seconde_Component'
import Third_Component from '../Component/Third_Component'
import Total_Count from '../Component/Total_Count'
import Testmonial_page from '../Component/Testmonial_page'
import Contact_Component from '../Component/Contact_Component'
import Footer from '../Component/Footer'
import Review_Component from '../Component/Review_Component'
import Zoom from 'react-reveal/Zoom';
import Collabration from './Collabration'
import Certified_comp from '../Component/Certified_comp';

function Main_Home_page() {
  useEffect(()=>{
    document.title='Home | InternsElite';
  },[]);
  return (
    <div>
      <Home_page/>
      <Zoom><Main_Brand_slider/></Zoom>
      <Collabration/>
      <Seconde_Component/>
      <Third_Component/>
      <Total_Count/>
      <Review_Component/>
      <Certified_comp/>
      <Contact_Component/>
    </div>
  )
}

export default Main_Home_page
